import React, { useEffect, useState } from 'react';

import FloatingLabelSelect from '../../common/components/FloatingLabelSelect';
import { humanize } from '../../common/utils';
import { IMMUNIZATION_FILTERS } from './ImmunizationsFilter';
import ImmunizationBadgesRow from './ImmunizationBadgesRow';
import ImmunizationStatusBadge from './ImmunizationStatusBadge';
import VaccineGroup from './VaccineGroup';

const ImmunizationRecordSection = ({
  immunizationRecords,
  recommendedImmunizationRecords,
  testGroupUser,
  ...props
}) => {

  const [filterValue, setFilterValue] = useState(IMMUNIZATION_FILTERS[0]);
  const [filteredImmunizationRecords, setFilteredImmunizationRecords] = useState(immunizationRecords);
  const [expandedVaccineGroup, setExpandedVaccineGroup] = useState(null);

  const filterRecords = () => {
    if (!immunizationRecords) return;
    if (!filterValue.value) return setFilteredImmunizationRecords(immunizationRecords);
    const keysWithMatches = [];
    Object.entries(immunizationRecords).forEach(([k, v]) => {
      const immunizationRecordStatus = v["immunization_record_status"];
      const matchInRecord = filterValue.value == immunizationRecordStatus;
      if (matchInRecord) keysWithMatches.push(k);
    })
    const filteredImmunizationRecords = Object.entries(immunizationRecords).filter(([k, v]) => keysWithMatches.includes(k));
    setFilteredImmunizationRecords(Object.fromEntries(filteredImmunizationRecords));
  };

  const handleFilterChange = (option) => {
    setFilterValue(option);
  };

  const handleVaccineGroupToggle = (vaccineName) => {
    setExpandedVaccineGroup(expandedVaccineGroup === vaccineName ? null : vaccineName);
  };

  useEffect(() => {
    filterRecords();
  }, [filterValue]);

  return (
    <>
      <div className="d-flex justify-content-between mb-3 mt-5">
        <h5 className="body-large-18-semibold">
          Immunization record
        </h5>
        <div style={{ width: '200px' }}>
          <FloatingLabelSelect
            defaultValue={filterValue}
            onChange={handleFilterChange}
            options={IMMUNIZATION_FILTERS}
            value={filterValue}
          />
        </div>
      </div>
      <div className="mb-5">
        <h6 className="body-large-16-semibold mb-3">
          {humanize(testGroupUser.student_profile.grade)} requirements
        </h6>
        <ImmunizationBadgesRow
          handleVaccineGroupToggle={handleVaccineGroupToggle}
          immunizationRecords={filteredImmunizationRecords}
        />
        <ImmunizationStatusBadge
          {...props}
        />
      </div>
      {Object.entries(filteredImmunizationRecords).map(([key, record]) => (
        <VaccineGroup
          handleVaccineGroupToggle={handleVaccineGroupToggle}
          immunizationRecordStatus={record.immunization_record_status}
          isRequired={true}
          record={record}
          show={expandedVaccineGroup === record.name}
          testGroupUser={testGroupUser}
          {...props}
        />
      ))}
      {Object.entries(recommendedImmunizationRecords).map(([key, record]) => (
        <VaccineGroup
          handleVaccineGroupToggle={handleVaccineGroupToggle}
          immunizationRecordStatus={record.immunization_record_status}
          isRequired={false}
          record={record}
          show={expandedVaccineGroup === record.name}
          testGroupUser={testGroupUser}
          {...props}
        />
      ))}
    </>
  )
};

export default ImmunizationRecordSection;